import { render, staticRenderFns } from "./DialogScorecardPersonalizado.vue?vue&type=template&id=4f328ec6&scoped=true&"
import script from "./DialogScorecardPersonalizado.vue?vue&type=script&lang=js&"
export * from "./DialogScorecardPersonalizado.vue?vue&type=script&lang=js&"
import style0 from "./DialogScorecardPersonalizado.vue?vue&type=style&index=0&id=4f328ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f328ec6",
  null
  
)

export default component.exports